import "pixi.js/unsafe-eval";
import { twitch_login_channel_name } from "./communication";
import { start_medium } from "./game";
import { twitch_service } from "./communication/api/twitch/twitch";
import { setup_plugin_system } from "./plugins";
import { Assets } from "pixi.js";
import { DoorController } from "@/client/door_controller";

Assets.init({
  preferences: {
    preferWorkers: false,
    preferCreateImageBitmap: false,
  },
});

setup_plugin_system();

const twitch_broadcast_channel = new BroadcastChannel(
  twitch_login_channel_name,
);

window.onload = async function () {
  const params = new URLSearchParams(window.location.search);
  if (params.has("code")) {
    twitch_broadcast_channel.postMessage({ auth_code: params.get("code") });
    window.close();
    return;
  }

  const canvas = document.getElementById("canvas");
  if (!canvas) {
    console.error("No canvas?!");
    return;
  }

  try {
    await DoorController.preload();
    const door_controller = new DoorController();
    door_controller.set_user_identifiable(twitch_service.canIdentifyUser);

    door_controller.door_clicked.subscribe(() => {
      if (twitch_service.canIdentifyUser) {
        start_medium();
        door_controller.hide_door();
      } else {
        twitch_service.requestIdShare();
      }
    });

    twitch_service.onAuth.subscribe(() => {
      door_controller.set_user_identifiable(true);
    });
  } catch (e) {
    if (e instanceof Error && e.message === "Door container not found") {
      start_medium();
    }
  }
};
